/**
 * Why the most recent validation attempt reached its verdict. Stored on the unversioned
 * `ThirdPartyApiCredentialActivity` sidecar; the versioned credential carries no validation state.
 */
export enum ThirdPartyApiValidationResult {
    /** This credential version has not been checked yet. Every edit lands here again. */
    NOT_VALIDATED = "NOT_VALIDATED",
    VALID = "VALID",
    /** Failed the service's `credentialFormat` — absent, blank, or malformed. No request was made. */
    INVALID_FORMAT = "INVALID_FORMAT",
    /** The host does not recognize the credential. */
    INVALID_UNRECOGNIZED = "INVALID_UNRECOGNIZED",
    /** Recognized, but lacks the permissions we need. */
    INVALID_INSUFFICIENT_PERMISSIONS = "INVALID_INSUFFICIENT_PERMISSIONS",
}

/** The subset a local format check can reach — it never contacts the host. */
export type ThirdPartyApiFormatValidationResult =
    | ThirdPartyApiValidationResult.VALID
    | ThirdPartyApiValidationResult.INVALID_FORMAT;
